import AgentWorkflowDetailsPage from "aiagent/AgentWorkflowDetailsPage";
import AgentWorkflowUsagePage from "aiagent/AgentWorkflowUsagePage";
import AgentWorkflowsPage from "aiagent/AgentWorkflowsPage";
import AgentWorkflowRunDetailsPage from "aiagent/AgentWorkflowRunDetailsPage";
import AgentWorkflowRunsPage from "aiagent/AgentWorkflowRunsPage";
import ModelProviderConfigPage from "aiagent/ModelProviderConfigPage";
import {
  PAGE_NAVIGATION_TITLE,
  RUNS_TITLE,
  SETTINGS_TITLE,
  USAGE_TITLE,
  WORKFLOWS_TITLE
} from "aiagent/AgentWorkflowPageNavigation";
import entityLinkResolvers from "aiagent/markdown/entityLinkResolvers";
import { AGENT_WORKFLOW_FEATURE_FLAG } from "aiagent/Constants";
import AgentWorkflowRoutes from "./Routes";
const pluginExports = {
  routes: [
    {
      path: AgentWorkflowRoutes.unqualified.WORKFLOWS,
      component: AgentWorkflowsPage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.workflowDetails(":id"),
      component: AgentWorkflowDetailsPage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.RUNS,
      component: AgentWorkflowRunsPage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.runDetails(":id"),
      component: AgentWorkflowRunDetailsPage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.USAGE,
      component: AgentWorkflowUsagePage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.SETTINGS,
      component: ModelProviderConfigPage,
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    }
  ],
  pageNavigation: [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        {
          description: WORKFLOWS_TITLE,
          path: AgentWorkflowRoutes.WORKFLOWS,
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
        },
        {
          description: RUNS_TITLE,
          path: AgentWorkflowRoutes.RUNS,
          permissions: ["agent_workflow:debug"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
        },
        {
          description: USAGE_TITLE,
          path: AgentWorkflowRoutes.USAGE,
          permissions: ["agent_workflow:manage"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
        },
        {
          description: SETTINGS_TITLE,
          path: AgentWorkflowRoutes.SETTINGS,
          permissions: ["agent_workflow:manage"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
        }
      ]
    }
  ],
  // Pluggable handlers for the `graylog://` URI scheme. Core's <Markdown> reads this
  // namespace, looks up the URI's first segment and either renders an in-app <Link> (for
  // resolvers returning {grnType, id}) or an anchor whose onClick({openSidebar}) opens an
  // entity in the right sidebar (for resolvers returning {onClick}). Our three resolvers
  // use the latter — core supplies `openSidebar` from its own `useRightSidebar` invocation.
  "markdown.entityLinkResolvers": [...entityLinkResolvers]
};
export default pluginExports;
